import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const PinIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M16.2143 8.65V3.9H17.1429C17.6536 3.9 18.0714 3.4725 18.0714 2.95C18.0714 2.4275 17.6536 2 17.1429 2H7.85714C7.34643 2 6.92857 2.4275 6.92857 2.95C6.92857 3.4725 7.34643 3.9 7.85714 3.9H8.78571V8.65C8.78571 10.227 7.54143 11.5 6 11.5V13.4H11.5436V20.05L12.4721 21L13.4007 20.05V13.4H19V11.5C17.4586 11.5 16.2143 10.227 16.2143 8.65Z'
                fill='currentColor'
            />
        </>
    ),
})

PinIcon.displayName = 'PinIcon'
